import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cake from "../Assets/cake.avif";
import "./Items.css";
import "./ItemsMobile.css";

function Items({ reverse }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLearnMore = () => {
    navigate("/details");
  };

  return (
    <>
      {!isMobile ? (
        <div 
          className={`custom-item-container ${reverse ? "custom-reverse" : ""}`} 
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className={`custom-inner-container ${isHovered ? "custom-hovered" : ""} ${reverse ? "custom-reverse" : ""}`}>
            <div className="custom-text-container">
              <h2>Delicious Chocolate Cake</h2>
              <p>A rich and creamy chocolate cake with a soft, moist texture.</p>
              <div className="custom-button-group">
                <button className="custom-learn-more" onClick={handleLearnMore}>Learn More</button>
                <button className="custom-order-now">Order Now</button>
              </div>
            </div>
          </div>
          <img src={cake} alt="Item" className={`custom-item-image ${reverse ? "custom-left" : "custom-right"}`} />
        </div>
      ) : (
        <div className={`custom-item-container-mobile ${reverse ? "custom-reverse" : ""}`}>
          <div className="custom-text-container-mobile">
            <h2>Delicious Chocolate Cake</h2>
            <p>A rich and creamy chocolate cake with a soft, moist texture.</p>
            <div className="custom-button-group-mobile">
              <button className="custom-learn-more-mobile" onClick={handleLearnMore}>Learn More</button>
              <button className="custom-order-now-mobile">Order Now</button>
            </div>
          </div>
          <img src={cake} alt="Item" className={`custom-item-image-mobile ${reverse ? "custom-left" : ""}`} />
        </div>
      )}
    </>
  );
}

export default Items;
